const swiperHomeSlider = new Swiper('.home-banner__contents', {
  loop: true,
  slidesPerView: 1,
  spaceBetween: 12,
  centeredSlides: true,
  speed: 15000,
  allowTouchMove: false,
  autoplay: {
    delay: 0,
    disableOnInteraction: false,
    pauseOnMouseEnter: false,
  },
  breakpoints: {
    580: {
      slidesPerView: 2,
      centeredSlides: false,
    },
    1360: {
      slidesPerView: 3,
      spaceBetween: 19,
      centeredSlides: false,
    }
  }
});